import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// get trial balance
export const getTrialBalance = createAsyncThunk(
  "TrialBalance/getTrialBalance",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.start_date)
        queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (
        params.include_zero_balance !== undefined &&
        params.include_zero_balance !== null &&
        params.include_zero_balance !== ""
      ) {
        queryParams.append("include_zero_balance", params.include_zero_balance);
      }
      const url = `${BASE_URL}/accounting-reports/trial-balance${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return { data: response.data, params };
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get trial balance!";
      return rejectWithValue(message);
    }
  },
);
